'use strict'
import * as THREE from 'three'
import Experience from '../Experience.js'
import Floor from './Floor.js'
import Fox from './Fox.js'
import Environment from './Environment.js'


export default class World
{
  constructor() {
    this.experience = new Experience()
    this.scene = this.experience.scene
    this.resources = this.experience.resources

    // Wait for resources
    this.resources.on('ready', () =>
    {
      // Setup
      this.floor = new Floor()
      this.fox = new Fox()
      this.environment = new Environment()
    })

    // Test Mesh
    const testMesh = new THREE.Mesh(
      new THREE.BoxGeometry(1, 0.5, 1.5),
      new THREE.MeshStandardMaterial({ color: 0x996633 })
    )
    testMesh.position.x = 2
    testMesh.position.y = 0.25
    testMesh.castShadow = true
    this.scene.add(testMesh)

    // Sphere
    const sphere = new THREE.Mesh(
      new THREE.SphereGeometry(0.5),
      new THREE.MeshStandardMaterial({ color: 'hsl(0, 0%, 10%)' })
    )
    sphere.position.set(-2, 0, -1)
    sphere.castShadow = true
    this.scene.add(sphere)

  }

  update()
  {
    if (this.fox)
      this.fox.update()
  }

}